@if ((layoutConfig$ | async)?.header) {
  <sb-member-header class="header" />
}
<div class="content-wrapper">
  <ng-container #content />
  <router-outlet />
</div>
<sb-icon-definitions />
@if (layoutConfig$ | async; as config) {
  @if (config.footer !== 'hidden') {
    <sb-footer [variant]="config.footer" />
  }
}
